import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/common/ScrollToTop";
import MainLayout from "./components/layout/MainLayout";
import NotFound from "./components/common/NotFound";

import Top from "./pages";

import Loto6 from "./pages/loto6";
import Loto7 from "./pages/loto7";
import Miniloto from "./pages/miniloto";
import Numbers3 from "./pages/numbers3";
import Numbers4 from "./pages/numbers4";
import Bingo5 from "./pages/bingo5";
import Qoochan from "./pages/qoochan";

import Loto6Stats from "./pages/loto6/stats";
import Loto7Stats from "./pages/loto7/stats";
import MinilotoStats from "./pages/miniloto/stats";
import Numbers3Stats from "./pages/numbers3/stats";
import Numbers4Stats from "./pages/numbers4/stats";
import Bingo5Stats from "./pages/bingo5/stats";
import QoochanStats from "./pages/qoochan/stats";

import Loto6Detail from "./pages/loto6/detail";
import Loto7Detail from "./pages/loto7/detail";
import MinilotoDetail from "./pages/miniloto/detail";
import Numbers3Detail from "./pages/numbers3/detail";
import Numbers4Detail from "./pages/numbers4/detail";
import Bingo5Detail from "./pages/bingo5/detail";
import QoochanDetail from "./pages/qoochan/detail";

import News from "./pages/news";
import Search from "./pages/search";
import Analysis from "./pages/analysis";
import Reports from "./pages/reports";
import About from "./pages/about";
import Privacy from "./pages/privacy";
import Terms from "./pages/terms";
import Changelog from "./pages/changelog";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MainLayout>
        <Routes>
          <Route path="/" element={<Top />} />

          <Route path="/loto6" element={<Loto6 />} />
          <Route path="/loto7" element={<Loto7 />} />
          <Route path="/miniloto" element={<Miniloto />} />
          <Route path="/numbers3" element={<Numbers3 />} />
          <Route path="/numbers4" element={<Numbers4 />} />
          <Route path="/bingo5" element={<Bingo5 />} />
          <Route path="/qoochan" element={<Qoochan />} />

          <Route path="/loto6/stats" element={<Loto6Stats />} />
          <Route path="/loto7/stats" element={<Loto7Stats />} />
          <Route path="/miniloto/stats" element={<MinilotoStats />} />
          <Route path="/numbers3/stats" element={<Numbers3Stats />} />
          <Route path="/numbers4/stats" element={<Numbers4Stats />} />
          <Route path="/bingo5/stats" element={<Bingo5Stats />} />
          <Route path="/qoochan/stats" element={<QoochanStats />} />

          <Route path="/loto6/detail/:round" element={<Loto6Detail />} />
          <Route path="/loto7/detail/:round" element={<Loto7Detail />} />
          <Route path="/miniloto/detail/:round" element={<MinilotoDetail />} />
          <Route path="/numbers3/detail/:round" element={<Numbers3Detail />} />
          <Route path="/numbers4/detail/:round" element={<Numbers4Detail />} />
          <Route path="/bingo5/detail/:round" element={<Bingo5Detail />} />
          <Route path="/qoochan/detail/:round" element={<QoochanDetail />} />

          <Route path="/news" element={<News />} />
          <Route path="/search" element={<Search />} />
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/changelog" element={<Changelog />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </MainLayout>
    </BrowserRouter>
  );
}

export default App;
